/**
 * author: Patrick Vyn Badiang
 */
import { Box, Typography } from "@mui/material";
import "./EventsPage.css";
import EventRow from "./EventRow";
import Calendar from "../../components/Calendar";

//Global Variables
import { useDirection } from "../../UtilityFunctions";

function EventsPage({activeSection}) {

  const isActive = activeSection === "events";
  const direction = useDirection();
  return (
    <div className={`animate__animated ${
      isActive ? "animate__fadeIn" : "animate__backOutUp"
        }`} 
        style={{
          opacity: isActive ? 1 : 0,
          visibility: isActive ? "visible" : "hidden",
          transition: isActive ? "opacity 0.5s ease, visibility 0.5s ease" : "opacity 0.2s ease, visibility 0.2s ease",
        }}
        >
    <div className="event-entire-page" >

      {direction === "horizontal" ? (
        <Box sx={{ display: "flex", flexDirection: { xs: "column", md: "row" }, justifyContent: "start", alignItems: "center", width: "100%", height: "100%", bgcolor: "transparent"}}>
          <Box sx={{ display: "flex", justifyContent: "end", alignItems: "start", width: "100%", ml: "50px", mr: "-50px",}}>
            <Calendar />
          </Box>
          
          <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "start", alignItems: "center", width: "100%", height: "100%", bgcolor: "transparent", mr: "-50px"}}>
            <Typography variant="h3" color="primary" sx = {{mb: "10px", mt: "-15px",}}> 
              Upcoming Event:
            </Typography>
            <EventRow/>
          </Box>
        </Box>
        
      ) : (
        <Box sx={{ display: "flex", flexDirection: { xs: "column", md: "row" }, alignContent: "center", alignItems: "center", width: "100%", height: "100%", bgcolor: "transparent"}}>
            <Typography variant="h3" color="primary" sx = {{mb: "10px", mt: "-15px",}}> 
              Upcoming Event:
            </Typography>
            <EventRow/>
        </Box>
      )}
      
      </div>
    </div>
  );
}

export default EventsPage;